// extracted by mini-css-extract-plugin
module.exports = {"frag":"Tab1_frag___FRty"};